//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/features.svg';
export default {
  name: 'GlobalQuote',
  props: {
    iconColor: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    },
    paragraph: {
      type: String,
      required: true
    }
  }
};